var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("tbody", [
    _c(
      "tr",
      { staticClass: "borderBottom" },
      [
        _c(
          "td",
          { staticClass: "px-2 py-4 text-left" },
          [
            _c("Badge", {
              staticClass: "inline",
              attrs: {
                value: _vm.status,
                color: _vm.badgeColor,
                styleClasses: "py-0.5 px-2",
              },
            }),
          ],
          1
        ),
        _c("td", { staticClass: "px-2 py-4 text-left" }, [
          _c("div", { staticClass: "request-info" }, [
            _vm._v(" " + _vm._s(_vm.requestJobTitle) + " "),
          ]),
        ]),
        _c(
          "td",
          { staticClass: "px-2 py-4 text-left" },
          [
            _c("ItemChipsWithMore", {
              attrs: { items: _vm.requestSkills, limit: 5 },
            }),
          ],
          1
        ),
        _c(
          "td",
          { staticClass: "px-2 py-4 text-left" },
          [
            _vm.skillIds.length
              ? [
                  _c("SuitableResources", {
                    attrs: {
                      skillIds: _vm.skillIds,
                      excludeResourceUserId: _vm.excludeResourceUserId,
                      companyId: _vm.companyId,
                    },
                  }),
                ]
              : [_c("p", { staticClass: "request-info" }, [_vm._v("n/a")])],
          ],
          2
        ),
        _c(
          "td",
          { staticClass: "px-2 py-4 text-left" },
          [
            _c("CollapsibleDescription", {
              attrs: {
                descriptionMaxLength: _vm.collapsibleDescriptionLength.MEDIUM,
                description: _vm.requestDescription,
              },
            }),
          ],
          1
        ),
        _c(
          "td",
          { staticClass: "px-2 py-4 text-left" },
          [
            _vm.requestCreatorLink
              ? _c("RouterLink", { attrs: { to: _vm.requestCreatorLink } }, [
                  _c(
                    "span",
                    {
                      staticClass:
                        "text-storm-gray text-sm p-1 font-medium rounded-full block border border-gray-300 bg-white borderCard hover:text-primary-500 hover:border-primary-500",
                    },
                    [
                      _vm.request.created_by
                        ? _c(
                            "div",
                            {
                              staticClass: "flex flex-row items-center",
                              attrs: {
                                name: "imageAvatar",
                                image: _vm.request.created_by.avatar,
                              },
                            },
                            [
                              _vm.request.created_by.avatar !== null
                                ? _c("S3Image", {
                                    class: [_vm.defaultImageClasses],
                                    attrs: {
                                      s3FileKey: _vm.request.created_by.avatar,
                                    },
                                  })
                                : _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-xs font-medium text-white justify-center flex items-center rounded-full border border-gray-300 bg-white w-6 h-6 mr-2",
                                      class: _vm.getAvatrClass,
                                      style: _vm.bgStyle,
                                    },
                                    [_vm._v(" " + _vm._s(_vm.initial) + " ")]
                                  ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-storm-gray text-sm font-medium",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.request.created_by.given_name
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.request.created_by.family_name
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _c("span", { staticClass: "request-info" }, [
                            _vm._v(" n/a "),
                          ]),
                    ]
                  ),
                ])
              : _c("p", { staticClass: "request-info" }, [_vm._v("n/a")]),
          ],
          1
        ),
        _c("td", { staticClass: "table-cell w-40" }, [
          _c(
            "div",
            [
              _c("MoreActions", {
                staticClass: "relative w-5",
                attrs: { TooltipBoxStyle: "tooltipTasks" },
                scopedSlots: _vm._u([
                  {
                    key: "action-buttons",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "flex flex-col bg-white" },
                          [
                            _vm.isRequestActive
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "actionLink",
                                    on: { click: _vm.toggleRequestModal },
                                  },
                                  [_vm._v(" Edit ")]
                                )
                              : _vm._e(),
                            _c(
                              "button",
                              {
                                staticClass: "actionLink",
                                on: { click: _vm.message },
                              },
                              [_vm._v(" Message ")]
                            ),
                            _c(
                              "RouterLink",
                              { attrs: { to: _vm.requestLink } },
                              [
                                _c("button", { staticClass: "actionLink" }, [
                                  _vm._v(" View more "),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ]),
        _vm.modalShown
          ? _c("CustomRequestModal", {
              attrs: {
                currentUserId: _vm.currentUserId,
                companyId: _vm.companyId,
                customRequest: _vm.request,
                skills: _vm.skillIds,
                isAdmin: _vm.isAdmin,
              },
              on: { close: _vm.toggleRequestModal, refetch: _vm.handleRefetch },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }